import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import { ExampleModal, ExampleVideoCard } from '../ExamplesPage';
import { SHOWCASE_COPY, SHOWCASE_ITEMS } from './landingContent';
import { LANDING_EVENTS, trackLandingEvent } from './landingAnalytics';
import { useLandingReveal, usePrefersReducedMotion } from './useLandingReveal';

function OutputShowcase() {
  const [activeExample, setActiveExample] = useState(null);
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();
  const visible = revealed || reducedMotion;

  return (
    <section id="examples" className="lp-section lp-showcase" aria-labelledby="lp-showcase-heading">
      <div className="lp-container">
        <div ref={revealRef} className={`lp-reveal${visible ? ' lp-reveal--visible' : ''}`}>
          <p className="lp-label">{SHOWCASE_COPY.label}</p>
          <h2 id="lp-showcase-heading" className="lp-heading">
            {SHOWCASE_COPY.heading}
          </h2>
          <p className="lp-body">{SHOWCASE_COPY.body}</p>
        </div>

        <div
          className="lp-showcase__scroller"
          role="list"
          aria-label="Example videos made with Latted"
        >
          {SHOWCASE_ITEMS.map((item) => (
            <div className="lp-device" role="listitem" key={item.id}>
              <ExampleVideoCard
                item={item}
                videoUrl={item.videoUrl}
                onOpen={(opened) => {
                  trackLandingEvent(LANDING_EVENTS.exampleOpened, { example_id: opened.id });
                  setActiveExample(opened);
                }}
              />
            </div>
          ))}
        </div>

        <div className="lp-showcase__footer">
          <p className="lp-showcase__disclosure">{SHOWCASE_COPY.disclosure}</p>
          <Link to="/examples" className="lp-showcase__more lp-focusable">
            {SHOWCASE_COPY.moreLink}
            <ArrowRight size={14} weight="bold" aria-hidden="true" />
          </Link>
        </div>
      </div>

      {activeExample && (
        <ExampleModal item={activeExample} onClose={() => setActiveExample(null)} />
      )}
    </section>
  );
}

export default OutputShowcase;
